import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { grey7 } from 'approot/shared/styles/colours.style';
import {
  hideNumberStepper,
  NumberInputStyled,
} from 'approot/shared/styles/inputs.style';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';

export const StepInputButtonStyled = styled.button`
  ${SecondaryBaseStyled}

  width: ${rem(23)};
  min-width: auto;
  height: ${rem(23)};
  border-radius: 50%;
  background: none;
  border: 1px solid ${grey7};
  padding: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StepInputStyled = styled(NumberInputStyled)`
  width: ${rem(56)};
  height: ${rem(40)};
  text-align: center;
  margin: 0 ${rem(spacing16)};

  ${hideNumberStepper}
`;
